/**
 * created by lei lei on 2020/6/12
 * 媒体信息组件
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Avatar, Card} from "antd";
import keepRecordIcon from './img/keepRecordIcon.png'
import exclamatioMark from './img/exclamatioMark.png'
import weChat from './img/wechat.png'
import microBlog from './img/microBlog.png'
import tiktok from './img/tiktok.png'
const {Meta} = Card;
export default class MediaInformation extends Component {
    static defaultProps = {
        title: '标题',
        customIconWidthHeight: 50,
        mark: 'xxx学院',
        dateMark: '',
        accountNumber: '731833645',
        iconUrl: '',
        bottomMark: '历史发布',
        customWidth: 324,
        colorType: 1,
        keepRecordIconShow: true,
    }
    static propTypes = {
        title: PropTypes.string.isRequired,//标题必传项
        iconUrl: PropTypes.string.isRequired,//左边图标部分，必传项
        mark: PropTypes.string.isRequired,//学院名称，必传项必传项
        dateMark: PropTypes.string.isRequired,//超过多长时间 必传项
        accountNumber: PropTypes.string.isRequired,//账号必传项
        customIconWidthHeight: PropTypes.number,//图标的宽高大小一个字段可选字段 非必传字段
        onClickFunction: PropTypes.func,//点击每一项非必传项 ,点击上半部分 非必传字段
        onClickBottomFunction: PropTypes.func,//点击底部按钮，非必传字段
        bottomMark: PropTypes.string,//底部文字描述非必传项非必传字段
        customWidth: PropTypes.number,//自定义宽度非必传字段
        colorType: PropTypes.number,//颜色类型类型非必传字段 需要使用颜色，请看代码里面的值
        keepRecordIconShow: PropTypes.bool,//是否显示备案图标非必传字段
        defaultImg:PropTypes.string.isRequired,//默认图片


    }

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let colorType = this.props.colorType;
        let needColor = '#999999';
        switch (colorType) {
            case 0 :
                needColor = '#999999';
                break;
            case 1 :
                needColor = '#ff9933';
                break;
            case 2 :
                needColor = '#ff0000';
                break;
            case 3 :
                needColor = '#ffcc00';
                break;

        }

        let iconType
        return (
            <div className={'MediaInformation'}>
                <Card hoverable={true} style={{ width: this.props.customWidth, height: 140}}
                      bodyStyle={{padding: 20}}>
                    <div onClick={() => {
                        this.props.onClickFunction && this.props.onClickFunction()
                    }}>
                        <Meta
                            avatar={
                                <div style={{
                                    width: this.props.customIconWidthHeight,
                                    height: this.props.customIconWidthHeight,
                                    background:'#bfbfbf',borderRadius: '5px'
                                }}>
                                    <img src={this.props.iconUrl?this.props.iconUrl:this.props.defaultImg} style={{ width: this.props.customIconWidthHeight,
                                        height: this.props.customIconWidthHeight,
                                        borderRadius: '5px'}}  alt=""/>
                                </div>
                                /*<Avatar style={{
                                width: this.props.customIconWidthHeight,
                                height: this.props.customIconWidthHeight,
                                background:'#bfbfbf'
                            }} src={this.props.iconUrl}/>*/}
                            title={
                                <div>
                                    <span style={{fontSize: 14}}>{this.props.title}</span>
                                    {
                                        this.props.keepRecordIconShow ?
                                            <img style={{width: 18, height: 18,marginLeft:3}} src={keepRecordIcon} alt=""/> :
                                            <img style={{width: 15, height: 15,marginLeft:3}} src={exclamatioMark} alt=""/>
                                    }

                                </div>

                            }
                            description={
                                <div style={{fontSize: 12}}>
                                    <div style={{display:'flex'}}>
                                        <div  style={{width:70,overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap'}} title={this.props.mark}>{this.props.mark}</div>
                                        <div style={{width:130,overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap'}} title={this.props.accountNumber}>账号：{this.props.accountNumber}</div>
                                    </div>
                                    <div style={{color: needColor,width:200,overflow: 'hidden',
                                        textOverflow: 'ellipsis',height:18,
                                        whiteSpace: 'nowrap',marginTop:5}} title={this.props.dateMark}>{this.props.dateMark}</div>
                                </div>
                            }
                        />
                    </div>
                    <div style={{height: 1, background: '#eeeeee', marginTop: 13}}/>
                    <div onClick={() => {
                        this.props.onClickBottomFunction && this.props.onClickBottomFunction()
                    }} style={{height:40,lineHeight:'40px', textAlign: 'center',fontSize:13,color:'#666666'}}>{this.props.bottomMark}</div>
                </Card>
            </div>
        )
    }

}